import * as styles from './WarningMessage.css';

export const WarningMessage = () => (
  <div className={styles['warning_message']}>Не вносите предоплату до просмотра объекта и заключения договора!</div>
);
